import type { Plugin } from 'vue'
import { createPinia } from 'pinia'
import Cookies from 'js-cookie'
import { createPersistedStatePlugin } from 'pinia-plugin-persistedstate-2'

export const plugin: Plugin = (app) => {
  const pinia = createPinia()

  const installPersistedStatePlugin = createPersistedStatePlugin({
    persist: true,
    storage: {
      getItem: async (key) => {
        return Cookies.get(key)
      },
      setItem: async (key: string, value: any) => {
        // console.log('setItem', key, value)
        Cookies.set(key, value, { secure: true })
      },
      removeItem: async (key) => {
        return Cookies.remove(key)
      },
    }
  })
  pinia.use((context) => installPersistedStatePlugin(context))

  app.use(pinia)
}